const items = document.querySelectorAll('.faq-list-item');

items.forEach(item => {
  const button = item.querySelector('.faq-list-item-button');
  const text = item.querySelector('.faq-list-item-text');

  // Начальные стили
  text.style.height = '0px';
  text.style.padding = '0'; // Только боковые отступы при закрытии
  text.style.overflow = 'hidden';
  text.style.transition = 'height 0.3s ease-out, padding 0.3s ease-out';

  item.addEventListener('click', function () {
    // Закрываем все элементы
    items.forEach(otherItem => {
      if (otherItem !== item) {
        const otherText = otherItem.querySelector('.faq-list-item-text');
        otherText.style.height = '0px';
        otherText.style.paddingTop = '0px';
        otherText.style.paddingBottom = '0px';
        otherItem.classList.remove('open');
        otherItem.querySelector('.faq-list-item-button').style.transform =
          'rotate(90deg)';
      }
    });

    // Открываем/закрываем текущий элемент
    if (item.classList.contains('open')) {
      text.style.height = '0px';
      text.style.paddingTop = '0px';
      text.style.paddingBottom = '0px';
      item.classList.remove('open');
      button.style.transform = 'rotate(90deg)';
    } else {
      text.style.height = text.scrollHeight + 19 + 0 + 'px';
      text.style.paddingTop = '16px'; // Возвращаем отступы
      text.style.paddingBottom = '0px';
      item.classList.add('open');
      button.style.transform = 'rotate(-90deg)';
    }
  });
});
